import * as HttpService from "../../../../service/HttpService";

/* 
获取表计配置列表
*/
export const getMeterModelItemConfigList = (params) => {
  return HttpService.get(HttpService.DOMAIN + `/meterModelItem/getMeterModelItemConfigList?modelCode=${params.modelCode}&pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`);
};

/* 
获取数据项编码下拉框数据
*/
export const getDataItem = (params) => {
  return HttpService.get(HttpService.DOMAIN + `/meterModelItem/getDataItem?modelCode=${params.modelCode}`);
};

/* 
获取表计配置详情
*/
export const getMeterModelItemConfig = (params) => {
  return HttpService.get(HttpService.DOMAIN + `/meterModelItem/getMeterModelItemConfig?id=${params.id}`);
};

/* 
新增表计配置
*/
export const addIesmsGmDevMeterModelMicConfig = (data) => {
  return HttpService.post(HttpService.DOMAIN + `/meterModelItem/addIesmsGmDevMeterModelMicConfig`, data);
};

/* 
编辑表计配置
*/
export const updateIesmsGmDevMeterModelMicConfig = (data) => {
  return HttpService.post(HttpService.DOMAIN + `/meterModelItem/updateIesmsGmDevMeterModelMicConfig`, data);
};

/* 
删除表计配置
*/
export const removeIesmsGmDevMeterModelMicConfig = (data) => {
  return HttpService.post(HttpService.DOMAIN + `/meterModelItem/removeIesmsGmDevMeterModelMicConfig`, data);
};

/* 
获取数据项列表
*/
export const getDataItemConfigList = (params) => {
  return HttpService.get(HttpService.DOMAIN + `/meterModelItem/getDataItemConfigList?measCommProto=${params.measCommProto}&pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`);
};

/* 
新增和编辑数据项
*/
export const addOrUpdateDataItem = (data) => {
  return HttpService.post(HttpService.DOMAIN + `/meterModelItem/addOrUpdateDataItem`, data);
};

/* 
删除数据项
*/
export const deletePointMeasItemCode = (data) => {
  return HttpService.post(HttpService.DOMAIN + `/meterModelItem/deletePointMeasItemCode`, data);
};

/* 
获取数据项详情
*/
export const getDataItemConfig = (params) => {
  return HttpService.get(HttpService.DOMAIN + `/meterModelItem/getDataItemConfig?id=${params.id}`);
};

/* 
下载编码表
*/
// export const downloadCodeTable = (params) => {
//   return HttpService.get(HttpService.DOMAIN + `/meterModelItem/downloadCodeTable?measCommProto=${params.measCommProto}`);
// };